import React, { useEffect, useState } from "react";
import { useContent } from "../hooks/useContent";
import { imageUrls } from "../lib/supabase";

const Header = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  // Dynamic content from Supabase
  const { content: title } = useContent(
    "header_title",
    "home",
    "Bun venit la Ali Cranta Medical Center"
  );
  const { content: subtitle } = useContent(
    "header_subtitle",
    "home",
    "Specializați în sănătatea pulmonară, vă oferim servicii medicale de înaltă calitate într-un mediu profesionist și prietenos."
  );
  const { content: button1Text } = useContent(
    "header_button_1",
    "home",
    "Află mai multe"
  );
  const { content: button2Text } = useContent(
    "header_button_2",
    "home",
    "Serviciile noastre"
  );

  useEffect(() => {
    // Preload the header background image
    const img = new Image();
    img.src = imageUrls.mainHeaderLogo();
    img.onload = () => {
      setImageLoaded(true);
    };
  }, []);

  return (
    <div
      className={`header-container container-fluid ${
        imageLoaded ? "image-loaded" : "image-loading"
      }`}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${imageUrls.mainHeaderLogo()})`,
      }}
    >
      <div className="header-content">
        <h1 className="header-h1">{title}</h1>
        <p className="header-subtitle">{subtitle}</p>
        <div className="header-buttons">
          <a href="#about" className="btn-get-started">
            {button1Text}
          </a>
          <a href="#services-wrapper" className="btn-services">
            {button2Text}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
